var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconTitle-setting",style:({
    background: _vm.data.backgroundColor,
    'margin-bottom': (_vm.data.marginBottom ) / 16 + 'rem',
    lineHeight: (_vm.data.lineHeight ) / 16 + 'rem',
  })},[_c('img',{staticClass:"iconTitle-setting-img",style:({
      width: (_vm.data.imgWidth ) / 16 + 'rem',
      height: (_vm.data.imgHeight ) / 16 + 'rem',
      'margin-left': (_vm.data.imgMarginLeft ) / 16 + 'rem',
      'margin-right': (_vm.data.imgMarginRight ) / 16 + 'rem',
    }),attrs:{"src":_vm.data.imgUrl}}),_c('div',[_c('div',{style:({
        fontSize: (_vm.data.fontSize ) / 16 + 'rem',
        fontWeight: _vm.data.fontWeight,
        color: _vm.data.titleColor,
        fontFamily: _vm.data.family,
      })},[_vm._v(_vm._s(_vm.data.title))]),(_vm.data.showSubTitle)?_c('div',{style:({
      fontSize: (_vm.data.subFontSize ) / 16 + 'rem',
      fontWeight: _vm.data.subFontWeight,
      color: _vm.data.subColor,
      fontFamily: _vm.data.subFamily,
      'margin-top': (_vm.data.subMarginTop ) / 16 + 'rem'
    })},[_vm._v(_vm._s(_vm.data.subTitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }